import { styled, css } from 'styled-components';
import { getFontSize, getFontWeight } from '../../abstracts';
import { dontForwardProps } from '../../util';
import { StateLayer } from '../../core-components';
const getBgColor = color => color === 'primary' ? 'var(--aui-primary)' : 'var(--aui-inverse-surface)';
export const Circle = styled.div.withConfig({
  componentId: "aui__sc-huxs0k-0"
})(["position:relative;overflow:hidden;box-sizing:border-box;height:", ";border-radius:var(--aui-border-radius-round);display:flex;justify-content:center;align-items:center;", ";"], ({
  $size
}) => $size === 'small' ? '2rem' : '3rem', ({
  $pinVariant,
  $size,
  $color
}) => $pinVariant === 'text' ? css(["min-width:3.75rem;background:var(--aui-surface);box-shadow:0 0 0 0.125rem ", " inset;padding:0 ", ";"], getBgColor($color), $size === 'small' ? `var(--aui-spacing-100)` : 'var(--aui-spacing-150)') : css(["width:", ";background:", ";"], $size === 'small' ? '2rem' : '3rem', getBgColor($color)));
export const Triangle = styled.div.withConfig({
  componentId: "aui__sc-huxs0k-1"
})(["position:absolute;z-index:-2;transform:scale(", ") rotate(45deg);height:0.5rem;width:0.5rem;left:calc(50% - 0.5rem / 2);top:", ";background:", ";"], Math.SQRT2, ({
  $size
}) => `calc(100% - ${$size === 'small' ? '0.5rem' : '0.375rem'})`, ({
  $color
}) => getBgColor($color));

//Icons and Text

export const TextElement = styled.span.withConfig({
  componentId: "aui__sc-huxs0k-2"
})(["font-size:", ";color:var(--aui-on-surface);padding:0 var(--aui-spacing-025);"], ({
  $size
}) => getFontSize($size === 'small' ? 1 : 2));
export const NumberElement = styled.span.withConfig({
  componentId: "aui__sc-huxs0k-3"
})(["font-size:", ";font-weight:", ";"], ({
  $size
}) => getFontSize($size === 'small' ? 2 : 4), getFontWeight('heavy'));
export const MapPinElement = styled.button.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-huxs0k-4"
})(["all:unset;background:transparent;position:relative;display:block;cursor:pointer;box-sizing:border-box;color:var(--aui-on-primary);z-index:5;", "{", "}&:hover ", "{opacity:var(--aui-state-layer-hover);}&:active ", "{opacity:var(--aui-state-layer-press);}&:focus-visible ", "{outline-offset:4px;outline:5px auto blue;}"], StateLayer, ({
  $selected
}) => $selected && `opacity: var(--aui-state-layer-press);`, StateLayer, StateLayer, Circle);